// extracted by mini-css-extract-plugin
export default {"resultName":"s4qwuX4u","resultParentName":"iqpKCzYG","result":"_20QLk1YZ","active":"_1LIfKnhd"};